import {
    OPEN_DILAOG,
    CLOSE_DILAOG,
    DIALOG_LOADING,
    FETCH_DIALOG_REQUEST,
    FETCH_DIALOG_ERROR,
    FETCH_DIALOG_SUCCESS
} from '../../actions'

const initialState = {
    open: false,
    loading: false
}

const dialog = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_DILAOG:
            return {
                ...state,
                open: action.payload.id,
                loading: false
            }
        case CLOSE_DILAOG:
            if(action.payload.id !== state.open) return state;
            return {
                ...state,
                open: null,
                loading: false
            }
        case DIALOG_LOADING:
            if(action.payload.id !== state.open) return state;
            return {
                ...state,
                loading: action.payload.loading
            }
        case FETCH_DIALOG_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_DIALOG_SUCCESS:
            return {
                ...state,
                open: null,
                loading: true
            }
        case FETCH_DIALOG_ERROR:
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

export default dialog



// WEBPACK FOOTER //
// ./src/reducers/ui/dialog.js